import { useMemo, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import {
  getTierGradient,
  readTierFromStorage,
  resolveTierFromUser,
} from '../utils/tier';

const useCustomerTier = () => {
  const { user } = useAuth();
  const lastTierRef = useRef(null);

  const tier = useMemo(() => {
    const fromUser = resolveTierFromUser(user);
    if (fromUser) return fromUser;
    return readTierFromStorage();
  }, [user]);

  if (tier) lastTierRef.current = tier;

  const effectiveTier = lastTierRef.current;
  const gradient = getTierGradient(effectiveTier);

  return {
    tier: effectiveTier,
    gradient,
  };
};

export default useCustomerTier;
